import { format } from "date-fns";
import { tz, TZDate } from "@date-fns/tz";

export function getUkDate(
  input: string | number | Date | null | undefined = new TZDate().withTimeZone(
    "Europe/London"
  )
) {
  return input
    ? new TZDate(
        // @ts-expect-error - TZDate is not typed correctly
        input,
        "Europe/London"
      ).withTimeZone("Europe/London")
    : new TZDate().withTimeZone("Europe/London");
}

export function formatUkDate(
  date: Parameters<typeof format>[0],
  options: Parameters<typeof format>[1]
) {
  return format(date, options, {
    in: tz("Europe/London"),
  });
}
